<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
            <b-navbar-brand href="#">
                <b-icon icon="person-square"></b-icon> ລາຍງານ
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
                <!-- <b-nav-item-dropdown right>
                           
                            <template #button-content>
                                ພາສາ
                            </template>
                        <b-dropdown-item href="#">LA</b-dropdown-item>
                        <b-dropdown-item href="#">EN</b-dropdown-item>
                    </b-nav-item-dropdown>   -->

                    <b-nav-item  @click="onApproved" >

                            <b-icon icon="cloud-check-fill" aria-hidden="true" variant="light"></b-icon> ຮັບຮອງບັດຜ່ານບັນຊີ
                    </b-nav-item>

                <b-nav-item @click="goback()">
                    <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
        <div>

            <div id="viewer"></div>

        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    methods: {
        goback() {
            this.$router.go(-1)
        },
        
       onApproved(){
        let params={
            doc_no: this.params.doc_no,
            posting_by: this.user.username

        }

        axios.post(this.$store.getters.getBaseUrl+'/approve_voucher',params)
        .then(res => {
            if(res.data.code==1){
                this.$router.go(-1)
            }else{
                this.$router.go('/error?desc='+res.data.desc)
            }

            console.log(res)
        })
        .catch(err => {
            console.error(err); 
        })
       }

    },
    name: 'app',
    data() {
        return {
            params: JSON.parse(this.$route.query.data),
            user:[]
        }
    },
    mounted: function () {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        //console.log( window.Stimulsoft)
        //  window.Stimulsoft.Base.StiLicense.loadFromFile('license.key')
        // window.Stimulsoft.Base.StiLicense.loadFromFile("license.key"); 
        // console.log('Loading Viewer view');

        // console.log('Creating the report viewer with default options');
        var viewer = new window.Stimulsoft.Viewer.StiViewer(null, 'StiViewer', false);

        // console.log('Creating a new report instance');

        var report = new window.Stimulsoft.Report.StiReport();

        //   console.log('Load report from url');
        report.loadFile('/reports/' + this.$route.params.reportname);

        var dataSet = new window.Stimulsoft.System.Data.DataSet("dataset");
        // var param= "?fromdate="+this.params.fromdate+"&todate="+this.params.todate+"&branch_id="+this.params.branch_id 
        let param = "branch_id=" + this.params.branch_id + "&script=" + this.params.script
        dataSet.readJsonFile(this.$store.getters.getBaseUrl +'/dataset?' + param, this.params);//one JSON object

        //this line of code added,too.
        report.dictionary.databases.clear();
        report.regData("dataset", "dataset", dataSet);
        // report.setVariable('caption', this.params.caption);
        for (const [key, value] of Object.entries(this.params)) {
            report.setVariable(key, value);
            console.log(`${key}: ${value}`);
        }
        //this line of code is also required.
        report.dictionary.synchronize();

        //  console.log('Assigning report to the viewer, the report will be built automatically after rendering the viewer');
        viewer.report = report;

        // console.log('Rendering the viewer to selected element');
        viewer.renderHtml('viewer');

        //  console.log('Loading completed successfully!');

    }
}
</script>

<style>
</style>
